import { graphql } from 'react-relay';

export type {
    nftPdpRespRootQuery$variables,
    nftPdpRespRootQuery as nftPdpRespRootQueryType,
} from './__generated__/nftPdpRespRootQuery.graphql.ts';

export const nftPdpRespRootQuery = graphql`
    query nftPdpRespRootQuery(
        $nftId: String!
        $userId: String = ""
        $fetchSplitName: Boolean = false
        $fetchUser: Boolean = false
        $fetchClientDetails: Boolean = false
        $isDraft: Boolean = false
        $creatorItemCount: Int = 4
    ) {
        viewer {
            ...NftPdpRespLayout_viewer
            ...NftHeaderLayout_viewer
            nftItems(nftIds: [$nftId], isDraft: $isDraft) {
                pdpUrl
                wasBurned
                removed
                creatorAddress {
                    publicProfile {
                        profileName
                    }
                }
                metadata {
                    ... on NftDigitalArtMetadata {
                        name
                        description
                        media {
                            webUrl
                            mimeType
                            posterFrameUrl
                        }
                    }
                }
            }
        }
    }
`;
